export const homeFallbackSections = [
  {
    _type: "hero",
    heading: "Welcome to August Twenty",
    body: "Elevate your business with expert insights tailored strategies and unwavering support",
    ctaLabel: "Contact Us",
    ctaLink: "/contact-us",
  },
  {
    _type: "clients",
    heading: "Our Clients",
    logos: ["/logoX.png", "/logoY.png", "/ASF.png", "/D&W.png", "/SwiftGo.png", "/IMG_1241.png", "/IMG_1242.png"],
  },
  {
    _type: "twoColumn",
    label: "Who are we",
    heading: "Expert consulting tailored to your business success",
    paragraphs: [
      "August Twenty is a consultancy firm specialising in providing solutions – Solution as a Service. We believe all businesses deserve solutions that deliver for them and their clients.",
      "Our capabilities extend from the delivery of large complex global business solutions in information technology to providing pain free support for our clients in complex emerging markets.",
    ],
  },
  {
    _type: "imageGrid",
    images: ["/home1.jpg", "/home2.jpg", "/home3.jpg"],
  },
  {
    _type: "servicesAccordion",
    eyebrow: "Services",
    heading: "Reliable expertise to drive your greatest success",
    image: "/services_pic.jpg",
    imageAlt: "Smiling Man",
    items: [
      { title: "Programme and Project Management", description: "Over 30 years' experience to guide and lead your business to optimise your project vision (goals and objectives) and support you in the delivery of your complete project life cycle." },
      { title: "Business Consultancy", description: "Providing you with expert analysis and strategic process improvement as well as guide your business through the digital age using modern tools and strategies" },
      { title: "Change and Transformation Management", description: "Helping your business prepare, generate momentum, and get ready for your business transformation" },
      { title: "Workspaces", description: "Providing you with an environment to create, enhance, and reinvigorate your ideas and vision" },
    ],
  },
  {
    _type: "contactSection",
    heading: "Get in touch",
    ukAddressLines: ["Kemp House, 128 City Road,", "London, England, EC1V 2NX"],
    ukPhone: "+44 (0) 7753 936903",
    liberiaAddressLines: ["Horton House, Horton Avenue,", "Monrovia, Liberia"],
    liberiaPhone: "+231 (0) 7774 47440",
    email: "enquiries@augusttwenty.co.uk",
    facebookUrl: "https://www.facebook.com/athortonhouse",
    instagramUrl: "https://www.instagram.com/athortonhouse/",
    linkedinUrl: "https://www.linkedin.com/company/august-twenty-limited/",
  },
];
